import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { CrudUrlStateBinding } from '@restavo/crud';

/**
 * The portal's half of the CRUD URL seam. `replace` is not optional: the search box writes
 * on every keystroke, so pushing would put one history entry per character between the user
 * and the previous page.
 */
export function useRouterUrlState(): CrudUrlStateBinding {
  const [params, setParams] = useSearchParams();
  const write = useCallback((next: URLSearchParams) => setParams(next, { replace: true }), [setParams]);
  return [params, write];
}
